export const ANY_VALUE = 'DOCUMENT';
